export const skills = [
  "./images/html5.png",
  "./images/css.png",
  "./images/js.png",
  "./images/react.png",
  "./images/node.png",
  "./images/redux.svg",
  "./images/next.svg",
  "./images/postgre.png",
  "./images/graph.png",
  "./images/strapi.png",
  "./images/git.png",
];
